export default __webpack_public_path__ + "01106477550eb42cdce0ac2c0efd4626.png";